module.exports = __webpack_public_path__ + "img/higher-other.967d3f9c.png";